// Rutas del portal de copropietarios. El tracking de HubSpot NUNCA debe cargarse
// ni reportar vistas en estas rutas. Blocklist: cualquier página pública nueva
// queda cubierta por el tracking automáticamente.
export const RUTAS_PRIVADAS = [
  '/login',
  '/portal',
  '/copropietarios',
  '/mi-cuenta',
  '/dashboard',
  '/calendar',
  '/payments',
  '/finance',
  '/fines',
  '/services',
  '/regulations',
  '/messages',
  '/concierge',
  '/my-properties',
  '/properties',
  '/opportunities',
  '/profile',
  '/admin',
];

export function esRutaPrivada(pathname) {
  const ruta = (pathname || '').toLowerCase();
  return RUTAS_PRIVADAS.some((p) => ruta === p || ruta.startsWith(`${p}/`));
}
